import localesConfig from 'app/config/locales.json';

export const localizedKm = (distanceInKm, locale) => {
    if (localesConfig[locale].units === 'imperial') {
        return distanceInKm * 0.62137;
    }

    return distanceInKm;
};
